import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bem-vinda(o) de volta!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="container-optia py-16">
      <div className="max-w-md mx-auto">
        <h1 className="font-display text-3xl font-semibold text-navy-900 text-center">Entrar na Optia</h1>
        <p className="text-slate-600 text-center mt-2">Bem-vinda(o) de volta.</p>
        <Card className="card-soft mt-8">
          <CardContent className="p-7">
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required data-testid="login-email" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="password">Senha</Label>
                <Input id="password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required data-testid="login-password" />
              </div>
              <Button type="submit" disabled={busy} className="w-full bg-teal-500 hover:bg-teal-600 h-11 rounded-xl" data-testid="login-submit">
                {busy ? "Entrando..." : "Entrar"}
              </Button>
            </form>
            <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
              <div className="flex-1 h-px bg-slate-200" /> ou <div className="flex-1 h-px bg-slate-200" />
            </div>
            <Button variant="outline" className="w-full h-11 rounded-xl border-slate-300" onClick={googleLogin} data-testid="login-google">
              <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
              Entrar com Google
            </Button>
            <p className="text-center text-sm text-slate-600 mt-6">
              Não tem conta? <Link to="/cadastro" className="text-teal-700 font-medium hover:underline" data-testid="login-goto-register">Criar cadastro</Link>
            </p>
            <p className="text-center text-xs text-slate-500 mt-4">Demo: <code className="text-teal-700">maria@optia.com / optia123</code></p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
